export enum ActivityLogTemplate {
  User = 'USER',
  Title = 'TITLE',
  Subtitle = 'SUBTITLE',
  Date = 'DATE',
  Action = 'ACTION',
}
